export const WITHDRAWAL_FORM = 'WITHDRAWAL_FORM';
